import React, { useState, useMemo } from 'react';
import faqData from '../../data/faq.json';

export default function Faq(){
  const [query, setQuery] = useState('');
  const [openId, setOpenId] = useState(null);

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return faqData;
    return faqData.filter(f => f.q.toLowerCase().includes(q) || (f.a && f.a.toLowerCase().includes(q)) || (f.bullets && f.bullets.join(' ').toLowerCase().includes(q)));
  }, [query]);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <header className="mb-6">
        <h1 className="text-3xl font-bold mb-2">Frequently Asked Questions</h1>
        <p className="text-gray-600">Frequently Asked Questions (FAQs) on HIV</p>
      </header>

      {/* <div className="mb-6 flex items-center gap-4">
        <input value={query} onChange={e=>setQuery(e.target.value)} placeholder="Search FAQ" className="flex-1 px-3 py-2 border rounded" />
        <button onClick={() => setQuery('')} className="px-3 py-2 bg-red-900 text-white rounded">Clear</button>
      </div> */}

      <div className="space-y-3">
        {results.map(item => (
          <div key={item.id} className="border rounded overflow-hidden">
            <button onClick={() => setOpenId(openId===item.id?null:item.id)} className="w-full text-left px-4 py-3 bg-white flex items-center justify-between">
              <span className="font-medium">{item.q}</span>
              <span className="text-gray-500">{openId===item.id ? '−' : '+'}</span>
            </button>

            {openId===item.id && (
              <div className="px-4 py-3 bg-gray-50 text-gray-800">
                <p className="mb-2">{item.a}</p>
                {item.bullets && (
                  <ul className="list-disc list-inside ml-2 text-gray-700">
                    {item.bullets.map((b,i) => <li key={i}>{b}</li>)}
                  </ul>
                )}
              </div>
            )}
          </div>
        ))}

        {results.length === 0 && (
          <div className="p-6 text-center text-gray-500">No results found</div>
        )}
      </div>
    </div>
  );
}
